var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Vcode",
    {
      attrs: { show: _vm.isShow },
      on: { success: _vm.onSuccess, close: _vm.close },
    },
    [_vm._v(" 1231 ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }